<div class="ui-g">
  <div class="ui-g-3 bg-color-1">
    <div *ngFor="let data of documentRawData">
      <div class="mb-3">
        @if (!data.isHidden) {
          <ng-container>
            <div class="title">{{ data.label }}</div>
            <ng-container [ngSwitch]="data.type">
              <div *ngSwitchCase="'array'">
                <table>
                  <tr *ngFor="let item of data.value">
                    {{
                      item
                    }}
                  </tr>
                </table>
              </div>
              <div *ngSwitchCase="'date'">
                {{ data.value | date: 'MM/dd/yyyy' : 'UTC' }}
              </div>
              <div *ngSwitchDefault>{{ data.value }}</div>
            </ng-container>
          </ng-container>
        }
      </div>
    </div>
  </div>
  <div class="ui-g-9">
    <div class="file-viewer">
      @if (!fileContentModel) {
        <div class="mh">
          <p-progressSpinner
            [style]="{ width: '100px', height: '100px' }"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"></p-progressSpinner>
        </div>
      }
      @if (fileContentModel) {
        <div>
          <app-preview-doc [fileContentModel]="fileContentModel">
          </app-preview-doc>
        </div>
      }
    </div>
  </div>
</div>
